import { Injectable } from '@angular/core';

/* eslint-disable no-console */

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  error(error: Error | string | unknown): void {
    console.error(error);
  }

  warn(...messages: unknown[]): void {
    console.warn(...messages);
  }

  debug(...messages: unknown[]): void {
    console.debug(...messages);
  }

  log(...messages: unknown[]): void {
    console.log(...messages);
  }
}
